export const SLICE_NAME = 'promotions';
